module.exports = __webpack_public_path__ + "img/images_project_bg2.0b22cc7b.png";